import * as companyApi from './moudules/companyApi';

// 默认导出
export default {
    companyApi
}
